import { render, staticRenderFns } from "./Role3.vue?vue&type=template&id=5e4e5f65&scoped=true&"
import script from "./Role3.vue?vue&type=script&lang=js&"
export * from "./Role3.vue?vue&type=script&lang=js&"
import style0 from "./Role3.vue?vue&type=style&index=0&id=5e4e5f65&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4e5f65",
  null
  
)

export default component.exports